import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const mockPosts = [
  {
    id: 1,
    title: 'Welcome to Our Blog!',
    excerpt: 'Discover the latest updates, tips, and news from our team.',
    content: 'Full content for Welcome to Our Blog! ...',
    author: 'Admin',
    created_at: '2024-06-01T10:00:00Z',
  },
  {
    id: 2,
    title: 'How to Get the Most from Our Service',
    excerpt: 'Maximize your experience with these expert tips.',
    content: 'Full content for How to Get the Most from Our Service ...',
    author: 'Jane Smith',
    created_at: '2024-06-02T14:30:00Z',
  },
];

const Blog = () => {
  const { user } = useAuth();
  const isAdmin = true; // Set to true for mockup; replace with real admin check

  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-xl shadow-soft">
      <h2 className="text-2xl font-bold mb-6">Blog & News</h2>
      {user && isAdmin && (
        <div className="mb-6 text-right">
          <Link to="/blog/new">
            <button className="bg-accent text-white px-4 py-2 rounded font-semibold hover:bg-primary transition">
              New Post
            </button>
          </Link>
        </div>
      )}
      <ul className="space-y-6">
        {mockPosts.map((post) => (
          <li key={post.id} className="border-b pb-4">
            <Link to={`/blog/${post.id}`} className="text-xl font-semibold text-primary hover:text-accent transition">
              {post.title}
            </Link>
            <div className="text-gray-500 text-sm mb-1">
              By {post.author} &middot; {new Date(post.created_at).toLocaleDateString()}
            </div>
            <div className="text-gray-700">{post.excerpt}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Blog; 